import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  console.error('UNHANDLED REJECTION reason =', event.reason);
});

window.onerror = (message, source, lineno, colno, error) => {
  console.error('window.onerror =>', { message, source, lineno, colno, error });
  return false;
};

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
